"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertFiatRate = void 0;
/* eslint-disable import/prefer-default-export */
const axios_1 = __importDefault(require("axios"));
const MARKETS_URL_BASE = `https://markets.api.bitcoin.com`;
const MARKETS_URL_RATES = "/rates/convertor";
const convertFiatRate = (base, quote, amount) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const { data } = yield axios_1.default.get(`${MARKETS_URL_BASE}${MARKETS_URL_RATES}`, {
            params: { c: base, q: quote },
        });
        return amount / data[quote].rate;
    }
    catch (error) {
        console.log("error convering fiat rate");
        return 0;
    }
});
exports.convertFiatRate = convertFiatRate;
//# sourceMappingURL=fiatRates.js.map